import { Link, createFileRoute } from "@tanstack/react-router";
import { UserIcon, ArrowUpTrayIcon } from "@heroicons/react/20/solid";
import Footer from "#/components/footer/footer";
import { metadataToHead } from "#/lib/seo";

const RegisterPage = () => {
  return (
    <>
      <main>
        <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <img
              className="mx-auto h-12 w-auto"
              src="/roamdoc-logo.png"
              alt="Roamdoc logo"
              width={256}
              height={102}
            />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-sky-600">
              Create your account
            </h2>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <form className="space-y-6" action="#" method="POST">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="new-password"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="confirm-password"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Confirm Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="confirm-password"
                      name="confirm-password"
                      type="password"
                      autoComplete="new-password"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="title"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Professional Title (e.g., MD, DO)
                  </label>
                  <div className="mt-1">
                    <input
                      id="title"
                      name="title"
                      type="text"
                      autoComplete="title"
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="specialization"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Specialization (e.g., Cardiology, Neurology)
                  </label>
                  <div className="mt-1">
                    <input
                      id="specialization"
                      name="specialization"
                      type="text"
                      autoComplete="specialization"
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="cv"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Upload your CV/Resume (PDF, DOCX)
                  </label>
                  <div className="mt-1 flex items-center">
                    <button className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-500">
                      <ArrowUpTrayIcon
                        className="mr-2 h-5 w-5 text-gray-500"
                        aria-hidden="true"
                      />
                      Upload file
                    </button>
                    <input
                      id="cv"
                      name="cv"
                      type="file"
                      className="hidden"
                      accept=".pdf, .doc, .docx"
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="group relative flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                  >
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <UserIcon
                        className="h-5 w-5 text-green-500 group-hover:text-green-400"
                        aria-hidden="true"
                      />
                    </span>
                    Create Account
                  </button>
                </div>
              </form>
            </div>

            <div className="mt-6 text-center">
              <p className="text-sm font-medium text-gray-700">
                Already have an account?
                <Link
                  to="/account/login"
                  className="ml-1 font-medium text-sky-600 hover:text-sky-500"
                >
                  Log in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default RegisterPage;

export const metadata = {
  title: "Create an Account • Roamdoc",
  description:
    "Create your Roamdoc account and apply to thousands of healthcare jobs.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/account/register`,
  },
};

export const Route = createFileRoute("/account/register/")({
  component: RegisterPage,
  head: () => metadataToHead(metadata),
});
